import { Component, Input, OnInit } from '@angular/core';

import { ApAnalyticsService } from '@ap/analytics';
import { ApContentService } from '@ap/content';
import { AvailableAnimations } from '@ap/animation';

import content from './mijn-error.content.json';

/**
 * @module  MijnErrorModule
 * @ngdoc component
 * @name MijnErrorComponent
 */
@Component({
    selector: 'mijn-error',
    templateUrl: 'mijn-error.component.html',
    styleUrls: ['./mijn-error.component.scss'],
    standalone: false
})
export class MijnErrorComponent implements OnInit {
    @Input()
    public title: string;

    public animationName: AvailableAnimations;

    public constructor(
        private readonly contentService: ApContentService,
        private readonly analyticsService: ApAnalyticsService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.sendPageviewAnalytics();

        this.animationName = this.contentService.get('mijn.error.animation.name') as AvailableAnimations;
    }

    private sendPageviewAnalytics(): void {
        this.analyticsService.pushPageview(
            'fout',
            'Mijn Omgeving',
            this.contentService.get('mijn.error.analytics.productCategory'),
            this.contentService.get('mijn.error.analytics.pageSiteSegment'),
            this.contentService.get('mijn.error.analytics.pageSiteSection'),
            this.contentService.get('mijn.error.analytics.platformName')
        );
    }
}
